import { render, staticRenderFns } from "./ResourceEdit.vue?vue&type=template&id=a3ee333e&scoped=true"
import script from "./ResourceEdit.vue?vue&type=script&lang=js"
export * from "./ResourceEdit.vue?vue&type=script&lang=js"
import style0 from "./ResourceEdit.vue?vue&type=style&index=0&id=a3ee333e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ee333e",
  null
  
)

export default component.exports